export function formatPhone( phone?: string, defaultValue?: string )
{
    
    
    if( phone == undefined || phone.trim().length == 0 ) return defaultValue;

    // If the leading zero was dropped, add it on
    if( phone.length == 9 && phone.startsWith( '13' ) == false && phone.startsWith( '18') == false )
    {
        phone =`0${phone}`;
    }

    // If there are fewer than 10 digits, the phone number is not valid
    if( phone.length < 10 ) return defaultValue;

    // Format as a 1300 / 1800
    if( phone.startsWith( '13') || phone.startsWith( '18') )
    {
        return `${ phone.slice( 0, 4 )} ${ phone.slice( 4, 6 )} ${ phone.slice( 6, 8 )} ${ phone.slice( 8, 10 )}`;
    }

    // Format as a mobile number
    if( phone.startsWith( '04') )
    {
        return `${ phone.slice( 0, 4 )} ${ phone.slice( 4, 7 )} ${ phone.slice( 7, 10 )}`;
    }

    // Format as a landline
    return `(${ phone.slice( 0, 2 )}) ${ phone.slice( 2, 6 )} ${ phone.slice( 6, 10 )}`;


}